import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exams',
  templateUrl: './exams.component.html',
  styleUrls: ['./exams.component.scss']
})
export class ExamsComponent implements OnInit {

  showMenuSidebar: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  menuButtonHandler() {
    this.showMenuSidebar = !this.showMenuSidebar;
  }

}
